import { auth } from '../firebase';

// Satu Flow, satu browser pada satu masa (2026-10-03) — panggilan "Pindah ke browser ini".
// Melepaskan browser yang sedang memegang Flow di server (functions/flowSessionBrowser.js
// `lepas`); Open Flow yang menyusul menuntutnya untuk browser ini. UI: FlowBrowserLain.jsx.
// Gagal dengan satu kod yang jelas supaya halaman boleh memberitahu pelanggan.
const API = import.meta.env.VITE_FLOW_SESSION_API || 'https://asia-southeast1-ai8saat.cloudfunctions.net/flowSessionPilot';

export async function lepasBrowser() {
    if (!auth.currentUser) throw new Error('RELEASE_FAILED');
    let r;
    try {
        r = await fetch(API + '/customer/release-browser', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + await auth.currentUser.getIdToken() },
            body: '{}', credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(30000) });
    } catch { throw new Error('RELEASE_FAILED'); }
    if (!r.ok) throw new Error('RELEASE_FAILED');
}
